import { render, staticRenderFns } from "./cms-component-glyph.vue?vue&type=template&id=c0b83b8c&scoped=true"
import script from "./cms-component-glyph.vue?vue&type=script&lang=js"
export * from "./cms-component-glyph.vue?vue&type=script&lang=js"
import style0 from "./cms-component-glyph.vue?vue&type=style&index=0&id=c0b83b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b83b8c",
  null
  
)

export default component.exports